@if (isLoading) {
  <div class="loading-overlay">
    <div class="loading-spinner"></div>
    <p>Loading map...</p>
  </div>
}

<div
  #dashboardContainerDiv
  class="dashboard-container"
  [class.loading]="isLoading"
>
  <div class="header-section">
    <!-- <div class="header">
      <span>{{ toolkitTitle }}</span>
    </div> -->

    <!-- Tabs Section -->
    <div class="tabs">
      @for (tab of ALLOWED_TABS; track tab; let i = $index) {
        <button
          class="tab-button"
          [class.active]="activeTab === tab"
          (click)="setActiveTab(tab)"
          [id]="'tour-map-tools-insights-' + i"
        >
          @switch (tab) {
            @case ("mapsFiltersSearch") {
              Map Filters & Layers
            }
            @case ("siteIntelligence") {
              Site Intelligence
            }
            @case ("siteBookmarks") {
              Site Bookmarks
            }
          }
        </button>
      }
      <div class="iframe-tools">
        <a
          href="javascript:void(0)"
          [title]="isFullscreen ? 'Exit Full Screen' : 'Full Screen'"
          (click)="toggleFullScreen()"
        >
          @if (!isFullscreen) {
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path
                d="M200 32L56 32C42.7 32 32 42.7 32 56l0 144c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79L73 295c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312l0 144c0 13.3 10.7 24 24 24l144 0c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l144 0c13.3 0 24-10.7 24-24l0-144c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-144c0-13.3-10.7-24-24-24L312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32z"
              />
            </svg>
          } @else {
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path
                d="M456 224l-144 0c-13.3 0-24-10.7-24-24l0-144c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L442.3 5.7C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8zm0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C466 510 461.1 512 456 512s-10-2-13.7-5.7L369 433l-40 40c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2l0-144c0-13.3 10.7-24 24-24l144 0zm-256 0c13.3 0 24 10.7 24 24l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L69.7 506.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369 39 329c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8l144 0zM56 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l40-40L5.7 69.7C2 66 0 61.1 0 56s2-10 5.7-13.7L42.3 5.7C46 2 50.9 0 56 0s10 2 13.7 5.7L143 79l40-40c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2l0 144c0 13.3-10.7 24-24 24L56 224z"
              />
            </svg>
          }
        </a>
      </div>
    </div>
  </div>

  <div class="content">
    <main class="main-container">
      <div class="main-column">
        <div class="map-container" id="siteIntelligenceMap">
          <div #mapViewContainer id="mapViewDiv"></div>
        </div>
      </div>

      <div class="main-row">
        <div class="map-container">
          <div #mapViewContainer id="mapViewDiv"></div>
        </div>
        @if (isMapLoaded) {
          @if (activeTab === "mapsFiltersSearch") {
            <div class="feature-info">
              <div class="search-filter-title colored-heading">
                Search for Specific Building Types (select one)
              </div>
              @for (filter of sidebarFilters; track $index) {
                <ng-container>
                  <app-site-toolkit-filters
                    [filterConfig]="filter"
                    [defaultValue]="'not_selected'"
                    (filterChange)="onFilterChange($event)"
                  ></app-site-toolkit-filters>
                </ng-container>
              }
              <app-site-toolkit-feature-info></app-site-toolkit-feature-info>
            </div>
          } @else if (activeTab === "siteIntelligence") {
            <div class="feature-info">
              <app-site-toolkit-intelligence
                [mapView]="mapView"
                [arcgisToken]="arcgisToken"
                [scrollToMap]="shouldScrollToMap"
              ></app-site-toolkit-intelligence>
            </div>
          } @else if (activeTab === "siteBookmarks") {
            <div class="feature-info">
              <app-site-toolkit-bookmarks
                [mapView]="mapView"
              ></app-site-toolkit-bookmarks>
            </div>
          }
        }
      </div>
    </main>
  </div>
</div>

@if (showRecordDetailsPopup) {
  <app-record-details
    [isActionButtonsAvailable]="false"
    [unique_id]="leadId"
    (popupClosed)="showRecordDetailsPopup = false"
  ></app-record-details>
}
